import React from 'react';
import { useAuthStore } from '../store/authStore';

export default function Debug() {
  const { user, token } = useAuthStore();

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <h1 className="text-3xl font-bold mb-6">Debug - User Info</h1>
      
      <div className="bg-gray-800 rounded p-6 mb-6">
        <h2 className="text-xl font-bold mb-4">User Object</h2>
        <pre className="bg-gray-900 p-4 rounded overflow-auto text-sm">
          {JSON.stringify(user, null, 2)}
        </pre>
      </div>

      <div className="bg-gray-800 rounded p-6 mb-6">
        <h2 className="text-xl font-bold mb-4">Token</h2>
        <details>
          <summary className="cursor-pointer">Click to expand token</summary>
          <pre className="bg-gray-900 p-4 rounded overflow-auto text-sm mt-4">
            {token}
          </pre>
        </details>
      </div>

      {token && (
        <div className="bg-gray-800 rounded p-6">
          <h2 className="text-xl font-bold mb-4">Decoded JWT</h2>
          <pre className="bg-gray-900 p-4 rounded overflow-auto text-sm">
            {JSON.stringify(
              JSON.parse(
                atob(token.split('.')[1])
              ),
              null,
              2
            )}
          </pre>
        </div>
      )}

      <div className="mt-8 space-y-4">
        <a href="/dashboard" className="block px-4 py-2 bg-blue-600 rounded hover:bg-blue-700 w-fit">
          Go to Dashboard
        </a>
        <button
          onClick={() => {
            localStorage.removeItem('token');
            window.location.href = '/login';
          }}
          className="px-4 py-2 bg-red-600 rounded hover:bg-red-700"
        >
          Clear Storage & Logout
        </button>
      </div>
    </div>
  );
}
